/**
 * @generated SignedSource<<c16fada76a6cb31452cd2a5560f07e72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useIsUserSignedIn_session$data = {
  readonly user: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "useIsUserSignedIn_session";
};
export type useIsUserSignedIn_session$key = {
  readonly " $data"?: useIsUserSignedIn_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsUserSignedIn_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useIsUserSignedIn_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "a3d9592d15c39d087e0f23116f7032d7";

export default node;
